/* eslint-disable react/destructuring-assignment */
import React from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    CcResponseList,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
} from "client/components"
import {
    Response,
    Bold,
} from "./styled"

export const HistoryResponse = ({
    history,
}: HistoryProps) => {
    const responseList = useSelector((state: StoreType) => state.ccResponse.responseList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const response = responseList[history.responseId]

    if (!response) return null
    return (
        <Response>
            <Bold>{`${lang.response}:`}</Bold>
            {response.response}
        </Response>
    )
}

export const HistoryResponsePdfExport = (
    history: HistoryType,
    responseList: CcResponseList,
    lang: LangType,
) => {
    const response = responseList[history.responseId]
    if (!response) return null
    return ({
        text: [
            {
                text: `${lang.response}: `,
                bold: true,
            },
            { text: response.response },
        ],
    })
}
